export default __webpack_public_path__ + "static/media/avatar-new.b7c9f7e4.png";